import { Component, OnInit } from '@angular/core';
import { LoginAsStoreService } from '../../../core/store/login-as.store.service';
import { AccountsService } from '../../../core/services/accounts.service';
import { AlertifyService, UserStore } from 'ccc-commons/core';
import { LoginAsService } from '../../../core/services/login-as.service';
import {Router} from '@angular/router';

@Component({
  selector: 'ccc-cca-user-logged-in',
  templateUrl: './user-logged-in.component.html'
})
export class UserLoggedInComponent implements OnInit {
  public userName: string;
  public marginBottom: boolean;
  constructor(public loggedUser: LoginAsStoreService,
              private loginAsService: LoginAsService,
              private accountService: AccountsService,
              private alertifyService: AlertifyService,
              private userStore: UserStore,
              private router: Router) {}

  ngOnInit() {
    this.loggedUser.hideMessage.subscribe( hide => {
      if (hide) {
        this.getAccount(this.loggedUser.assumedId);
      }
    });
    this.marginBottom = this.router.url.includes('organization/root/list') || this.router.url.includes('organization/root/coach');
    // Initial load logic
    this.loggedUser.assumedId = this.userStore.getUserValue()['assumedId'];
    if (this.loggedUser.assumedId) {
      this.loggedUser.hideMessage.next(true);
    }
  }

  onRemoveLoggedIn() {
    this.loginAsService.removeLoginAs().subscribe( () => {
      this.alertifyService.success('Login as removed sucessfully');
    });
  }

  private getAccount(accountId: string) {
    this.accountService.getAccountById(accountId).subscribe( account => {
      this.userName = account.body.firstName;
    });
  }
}
